import {Box, Button, Card, CardContent, Grid, Typography} from "@mui/material";
import {Done} from "@mui/icons-material";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";
import {Close, DoneFilled} from "~/ui/icons";
import React, {useEffect} from "react";
import makeStyles from "@mui/styles/makeStyles";
import {PortTheme} from "~/ui/theme";
import {Admission, AdmissionTypeEnum} from "~/queries";
import {
    CreateAdmissionResultCard
} from "~/apps/packages/passes/components/CreateAdmissionResultCard/CreateAdmissionResultCard";
import {GraphQLError} from "graphql";
import {noun} from "plural-ru";
import {useHistory, useLocation} from "react-router-dom";


export type AdmissionCreateResultProps = {
    onContinue?: () => void
    admission: {
        CAR?: Admission
        PEDESTRIAN?: Admission
    },
    error: {
        CAR?: GraphQLError,
        PEDESTRIAN?: GraphQLError,
    },
}


const useStyles = makeStyles<PortTheme, AdmissionCreateResultProps>(theme => ({
    mainCard: {
        marginBottom: 16,
    },
    iconContainer: {
        width: 100,
        height: 100,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#FFFFFF",
        padding: 22,
        fontWeight: 700,
        backgroundColor: theme.palette.additionalPrimary.main,
        backgroundClip: "padding-box",
        borderRadius: 106,
        borderStyle: "solid",
        borderColor: "#009ACF19",
        borderWidth: 15,
        "& .MuiSvgIcon-root": {
            width: 40,
            height: 40,
        }
    },
    iconContainerError: {
        backgroundColor: '#C83C33',
        borderColor: 'rgba(200, 60, 51, 0.1)'
    },
    content: {
        paddingTop: "65px !important",
        paddingBottom: "65px !important",
        textAlign: "center"
    },
}));


export const AdmissionCreateResult = (props: AdmissionCreateResultProps) => {
    const classes = useStyles(props);
    const {onContinue, admission, error} = props;
    const history = useHistory<any>();

    const handleNextClick = () => {
        onContinue && onContinue();
    }

    const goBack = () => {
        history.goBack();

        setTimeout(() => {
            onContinue();
        }, 0);
    };

    useEffect(() => {
        window.addEventListener('popstate', goBack);
        return () => {
            window.removeEventListener('popstate', goBack);
        };
    }, []);

    return (
        <>
            <Card className={classes.mainCard}>
                <CardContent className={classes.content}>
                    <Grid container direction="column" alignItems="center">
                        <Grid item>
                            <div className={[classes.iconContainer, (error?.CAR || error?.PEDESTRIAN) && classes.iconContainerError].join(' ')}>
                                {
                                    (error?.CAR || error?.PEDESTRIAN)
                                        ? <Close />
                                        : <Done color="inherit"/>
                                }
                            </div>
                        </Grid>
                        <Grid item marginTop="32px">
                            {
                                (error?.CAR || error?.PEDESTRIAN)
                                    ? <Typography variant="screenTitle" color="primary">
                                            Не удалось создать заявки
                                        </Typography>
                                    : <Typography variant="screenTitle" color="primary">
                                            {noun(Object.entries(admission || {}).length, 'Заявка успешно создана', 'Заявки успешно созданы', 'Заявок успешно создано')}
                                        </Typography>
                            }
                        </Grid>
                        <Grid item marginTop="11px">
                            {
                                (error?.CAR || error?.PEDESTRIAN)
                                    ? <Typography variant="screenText" color="secondary">
                                        Ошибка
                                    </Typography>
                                    : <Typography variant="screenText" color="secondary">
                                        {noun(Object.entries(admission || {}).length, 'Создана 1 заявка', 'Создано 2 заявки', `Создано ${Object.entries(admission || {}).length} заявок`)}
                                    </Typography>
                            }
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            {
                admission?.PEDESTRIAN && (
                    <CreateAdmissionResultCard type={AdmissionTypeEnum.Pedestrian} error={error?.PEDESTRIAN} />
                )
            }
            {
                admission?.CAR && (
                    <CreateAdmissionResultCard type={AdmissionTypeEnum.Car} error={error?.CAR} />
                )
            }
            <Box minHeight={80} height={80}/>
            <FloatingActions>
                <Button fullWidth onClick={handleNextClick} startIcon={<DoneFilled/>}>
                    Готово
                </Button>
            </FloatingActions>
        </>
    )
}
